export default {
  sidebar: {
    dashboard: "Dashboard",
    collections: "Collections",
    payments: "Payments",
    transactions: "Transactions",
    collectedPayments: "Collected Payments",
    transfers: "Transfers",
    pendingTransfers: "Pending Transfers",
    linksToValidateLevel1: "Links to Validate (Level 1)",
    linksToValidateLevel2: "Links to Validate (Level 2)",
    contacts: "Contacts",
    crm: "CRM",
    organizations: "Organizations",
    users: "Users",
    myAccounts: "My Accounts",
    finances: "Finances",
    refunds: "Refunds",
    reloads: "Reloads",
    business: "Business",
    balance: "Balance",
    operationsStatement: "Operations Statement",
    settings: "Settings",
    countries: "Countries",
    feeTypes: "Fee Types",
    fees: "Fees",
    providers: "Providers",
    operators: "Operators",
    permissions: "Permissions",
    actions: "Actions",
    accountConfiguration: "Account Configuration",
    settingsConfiguration: "Settings Configuration",
    logout: "Logout"
  },
  "doubleEntries": {
      "title": "Double entries",
      "total_entries": "{count} entries",
      "refresh": "Refresh",
      "loading": "Loading...",
      "search_placeholder": "Search in description",
      "filters": "Filters",
      "filters_title": "Filter entries",
      "apply": "Apply",
      "reset": "Reset",
      "cancel": "Cancel",
      "close": "Close",
      "copy": "Copy",
      "all": "All",
      "actions": "Actions",
      "view_detail": "View details",
      "detail_title": "Entry details",
      "date": "Date",
      "reference": "Reference",
      "external_reference": "External reference",
      "description": "Description",
      "debit": "Debit",
      "credit": "Credit",
      "amount": "Amount",
      "exact_amount": "Exact amount",
      "min_amount": "Minimum amount",
      "max_amount": "Maximum amount",
      "currency": "Currency",
      "entry_type": "Entry",
      "entity": "Entity",
      "entity_type": "Entity type",
      "entity_code": "Entity code",
      "status": "AdjustmentType",
      "other_entries": "Other entries",
      "other_entries_title": "Other entries of the entity",
      "view_other_entries": "View the {count} other entries",
      "detail_general": "General Information",
      "detail_ledger_entries": "Ledger Entries",
      "detail_transaction": "Associated Transaction",
      "detail_topup": "Top-up",
      "detail_repayment": "Repayment",
      "detail_integrity": "Integrity",
      "integrity_hash": "Integrity Hash",
      "previous_hash": "Previous Hash",
      "merchant_account_type": "Merchant Account Type",
      "provider_balance_type": "Provider Balance Type",
      "error_loading_detail": "Unable to load the ledger entry details.",
      "retry": "Retry",
      "tx_code": "Transaction Code",
      "tx_payout_id": "Payout ID",
      "tx_checkout_id": "Checkout ID",
      "tx_int_bulk_id": "Bulk ID",
      "tx_int_operator_bulk_id": "Operator Bulk ID",
      "tx_bank_transfert_id": "Bank Transfer ID",
      "tx_transaction_type": "Transaction Type",
      "tx_payout_type": "Payout Type",
      "tx_bank_transfert_type": "Bank Transfer Type",
      "tx_amount": "Amount",
      "tx_bulk_total_amount": "Bulk Total Amount",
      "tx_total_fees": "Total Fees",
      "tx_imoney_fees": "iMoney Fees",
      "tx_operator_fees": "Operator Fees",
      "date_from": "From date",
      "date_to": "To date",
      "order": "Order",
      "order_desc": "Newest",
      "order_asc": "Oldest",
      "per_page": "Per page",
      "real": "Real",
      "virtual": "Virtual",
      "normal": "Normal",
      "no_entries": "No entries found",
      "showing": "Showing {count} of",
      "copy_reference": "Click to copy the reference",
      "copied": "Copied",
      "error_loading": "Error while loading entries",
      "error_amount_range": "Minimum amount must be lower than maximum amount",
      "error_date_range": "Start date must be before end date",
      "error_occurred": "An error occurred"
    },
  "merchants": {
    "create": "Create",
    "search_organization": "Search for an organization...",
    "organization": "Organization",
    "main_account": "Main account",
    "main_balance": "Main balance(XOF)",
    "other_accounts": "Other accounts",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "no_organization": "No organization found.",
    "showing": "{count} organization(s) displayed out of",
    "view": "View",
    "edit": "Edit",
    "change_status": "Change status",
    "create_merchant_accounts": "Create merchant accounts",
    "cancel": "Cancel",
    "other_accounts_title": "Other accounts",
    "type": "Type",
    "name": "Name",
    "balance": "Balance",
    "blocked_balance": "Blocked balance",
    "track_balance": "Track balance",
    "created_at": "Created at",
    "close": "Close",
    "organization_info": "Organization information",
    "code": "Code",
    "description": "Description",
    "organization_status": "Organization status",
    "email": "Email",
    "contact": "Contact",
    "bank_domiciliation": "Bank domiciliation",
    "rib": "RIB",
    "created_on": "Created on",
    "organization_accounts": "Organization accounts",
    "edit_account": "Edit an account",
    "account_to_edit": "Account to edit",
    "select_account": "Select an account",
    "account_type": "Account type",
    "save": "Save",
    "change_status_title": "Change status",
    "account": "Account",
    "validate": "Validate",
    "yes": "Yes",
    "no": "No",
    "loading": "Loading...",
    "load_more_organizations": "Load more organizations",
    "please_select_organization": "Please select an organization.",
    "please_select_account": "Please select an account.",
    "merchant_accounts_created": "Merchant account(s) created",
    "merchant_account_updated": "Merchant account updated",
    "status_updated": "Status updated",
    "error_loading_organizations": "Error loading organizations",
    "error_occurred": "An error occurred.",
    "view_other_accounts": "View the {count} other accounts"
  },
  dashboard: {
    "totalTransactionPerMonth": "Total transaction amount per month",
    "weeklyCollections": "WEEKLY COLLECTIONS"
  },
  breadCrumb: {
    transTitleP: "Collected Payments",
    "doubleentrylist":"Double-Entry List",
    marchantAccountListe: "Merchant Account List",
    transTitleD: "Collections",
    "title": "Token Management",
    "collectedPaymentsBy": "Collected Payments by",
    "leadDetails": "Lead Details",
    "clientList": "Client List",
    "organisationlist": "Organizations list",
    "myDirectory": "My Directory",
    "contactsList": "Contacts List",
    "multipleTransfer": "Multiple Transfer",
    "pendingTransfersList": "Pending Transfers List",
    "moneyTransfers": "Money Transfers",
    "users": "Users",
    "level1ValidationLinks": "Level 1 Validation Links List",
    "level2ValidationLinks": "Level 2 Validation Links List",
    "refundsList": "Refunds List",
    "settingsConfiguration": "Settings Configuration",
    "accountConfiguration": "Account Configuration",
    "actionsList": "Actions List",
    "permissionsList": "Permissions List",
    "operatorsList": "Operators List",
    "provider": "Provider",
    "feesList": "Fees List",
    "countriesList": "Countries List",
    "providerBalances": "Provider Balances",
    "myAccount": "My Account",
    "changeMyPassword": "Change My Password",
    "privacyPolicy": "Privacy Policy",
    "socialLinks": "Social Links",
    "feeTypesList": "Fee Types List"
  },
  
  transactions: {
    export: "Export",
    link: "Link",
    "payment": " Payment",
    "collection": " Collection",
    "code": "TRANSACTION CODE",
    "operator": "OPERATOR",
    "description":"DESCRIPTION",
    "phone": "PHONE",
    "amount": "AMOUNT",
    "processingDate": "Processing date",
    "date": "DATE",
    "status": "STATUS",
    "success": "SUCCESS",
    "failed": "FAILED",
    "processing": "PROCESSING",
    "pending": "PENDING",
    "view": "View",
    "receipt": "Receipt",
    "claim": "Claim",
    "exportExcel": "Export transactions to excel",
    "advancedSearch": "Advanced Search",
    "clients": "Clients",
    "select": "Select...",
    "country": "Country",
    "senegal": "Senegal",
    "ivoryCoast": "Ivory Coast",
    "operators": "Operators",
    "statuses": "Statuses",
    "startDate": "Start Date",
    "endDate": "End Date",
    "category": "Category",
    "subCategory": "Sub-category",
    "selectSubCategory": "Select a sub-category",
    "phoneNumber": "Phone Number",
    "transactionDetails": "Transaction Details",
    "transactionCode": "Transaction Code",
    "operatorReference": "Operator Reference",
    "paymentLink": "Payment Link",
    "refresh": "Refresh",
    "generatePaymentLink": "Generate Payment Link",
    "paymentQRCode": "Payment QR Code",
    "scanToPay": "Scan to pay",
    "close": "Close",
    "download": "Download",
    "transactionReceipt": "TRANSACTION RECEIPT",
    "amountLabel": "AMOUNT......................................",
    "statusLabel": "STATUS...........................................",
    "beneficiary": "BENEFICIARY",
    "thankYou": "THANK YOU FOR YOUR TRUST!",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results",
    "editionDate": "EDITION DATE",
    "listTitle": "TRANSACTION LIST",
    "period": "Period from",
    "to": "to",
    "excel": "Excel",
    "pdf": "Pdf",
    "showQRCode": "Show QR code",
    "advancedDetails": "Advanced Information",
    "payoutId": "Payout ID",
    "bulkId": "Bulk ID",
    "technicalStatus": "Technical Status",
    "validationStatus": "Validation Status",
    "statusCode": "Status Code",
    "operationType": "Operation Type",
    "payin": "Pay-in",
    "payout": "Payout",
    "currency": "Currency",
    "countryCode": "Country Code",
    "imoneyFees": "i-Money Fees",
    "operatorFees": "Operator Fees",
    "initiatedByUser": "Initiated By",
    "businessLabel": "Business",
    "clientReference": "Client Reference",
    "clientId": "Client ID",
    "descriptionLabel": "Description",
    "handlingDate": "Processing Date",
    "finalStateDate": "Final Status Date",
    "checkingDate": "Verification Date",
    "apiVersion": "API Version",
    "errorMessage": "Error Message"
  },

  transfers: {
    "export": "Export",
    "paymentLink": "Payment Link",
    "noResultForExport": "No transactions found for these criteria, export is not possible.",
    "code": "TRANSACTION CODE",
    "beneficiary": "BENEFICIARY",
    "description": "DESCRIPTION",
    "operator": "OPERATOR",
    "phone": "PHONE",
    "amount": "AMOUNT",
    "date": "DATE",
    "status": "STATUS",
    "validation": "VALIDATION",
    "success": "SUCCESS",
    "failed": "FAILED",
    "processing": "PROCESSING",
    "pending": "PENDING",
    "initiated": "INITIATED",
    "scheduled": "SCHEDULED",
    "draft": "DRAFT",
    "validated": "VALIDATED",
    "rejected": "REJECTED",
    "level1": "Level 1",
    "level2": "Level 2",
    "view": "View",
    "downloadReceipt": "Download Receipt",
    "copyLink": "Copy Link",
    "claim": "Claim",
    "multipleSend": "Multiple Send",
    "singleSend": "Single Send",
    "sendMoney": "Send Money",
    "balance": "BALANCE",
    "operators": "Operators",
    "select": "Select...",
    "clients": "Clients",
    "category": "Category",
    "subCategory": "Sub-category",
    "selectSubCategory": "Select a sub-category",
    "phoneNumber": "Phone Number",
    "descriptionPlaceholder": "Description",
    "send": "Send",
    "exportTransactions": "Export Transactions",
    "advancedSearch": "Advanced Search",
    "country": "Country",
    "senegal": "Senegal",
    "ivoryCoast": "Ivory Coast",
    "statuses": "Statuses",
    "startDate": "Start Date",
    "endDate": "End Date",
    "transactionDetails": "Transaction Details",
    "transactionCode": "Transaction Code",
    "operatorReference": "Operator Reference",
    "refresh": "Refresh",
    "generatePaymentLink": "Generate Payment Link",
    "validationType": "Validation Type",
    "simple": "SIMPLE",
    "double": "DOUBLE",
    "link": "Link",
    "transactionReceipt": "TRANSACTION RECEIPT",
    "amountLabel": "AMOUNT......................................",
    "statusLabel": "STATUS...........................................",
    "thankYou": "THANK YOU FOR YOUR TRUST!",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results",
    "editionDate": "Edition Date",
    "listTitle": "Transaction List",
    "period": "Period from",
    "to": "to",
    "excel": "Excel",
    "pdf": "Pdf"
  },

  validation: {
    "cancel": "Cancel",
    "confirm": "Confirm",
    "code": "TRANSACTION CODE",
    "beneficiary": "BENEFICIARY",
    "operator": "OPERATOR",
    "phone": "PHONE",
    "search": "Search...",
    "amount": "AMOUNT",
    "date": "DATE",
    "status": "STATUS",
    "success": "SUCCESS",
    "failed": "FAILED",
    "processing": "PROCESSING",
    "pending": "PENDING",
    "initiated": "INITIATED",
    "scheduled": "SCHEDULED",
    "alert": "Alert",
    "no": "No",
    "yes": "Yes"
  },

  linkValidation: {
    "code": "TRANSACTION CODE",
    "beneficiary": "BENEFICIARY",
    "operator": "OPERATOR",
    "phone": "PHONE",
    "amount": "AMOUNT",
    "validationStatus": "Validation Status",
    "paymentStatus": "Payment Status",
    "draft": "Draft",
    "validated": "Validated",
    "rejected": "Rejected",
    "expired": "Expired",
    "unknown": "Unknown",
    "noAction": "No action available",
    "date": "DATE",
    "expirationDate": "EXPIRATION DATE",
    "status": "STATUS",
    "actions": "ACTIONS",
    "success": "SUCCESS",
    "failed": "FAILED",
    "processing": "PROCESSING",
    "pending": "PENDING",
    "initiated": "INITIATED",
    "scheduled": "SCHEDULED",
    "alert": "Alert",
    "no": "No",
    "yes": "Yes",
    "listTitle": "Transaction List",
    "transactionDetails": "Transaction Details",
    "transactionCode": "Transaction Code"
  },
  linkValidationLevel2: {
    "code": "TRANSACTION CODE",
    "beneficiary": "BENEFICIARY",
    "operator": "OPERATOR",
    "phone": "PHONE",
    "amount": "AMOUNT",
    "date": "DATE",
    "status": "STATUS",
    "actions": "ACTIONS",
    "success": "SUCCESS",
    "failed": "FAILED",
    "processing": "PROCESSING",
    "pending": "PENDING",
    "initiated": "INITIATED",
    "scheduled": "SCHEDULED",
    "alert": "Alert",
    "no": "No",
    "yes": "Yes",
    "listTitle": "Transaction List",
    "transactionDetails": "Transaction Details",
    "transactionCode": "Transaction Code"
  },
  users: {
    "createUser": "Create User",
    "id": "ID",
    "name": "NAME",
    "username": "USERNAME",
    "organization":"ORGANIZATION",
    "email": "E-MAIL",
    "role": "ROLE",
    "type": "TYPE",
    "generatePassword": "Generate password",
    "generatedPassword": "Generated password",
    "status": "STATUS",
    "validator": "VALIDATOR",
    "active": "ACTIVE",
    "inactive": "INACTIVE",
    "yes": "YES",
    "no": "NO",
    "edit": "Edit",
    "activateValidator": "Activate Validator",
    "deactivateValidator": "Deactivate Validator",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "permission": "Permission",
    "permissionManagement": "Permission Management",
    "list": "List",
    "assign": "Assign",
    "restore": "Restore",
    "code": "CODE",
    "availablePermissions": "Available Permissions",
    "revoke": "Revoke",
    "revokeReason": "Revocation reason...",
    "create": "Create",
    "user": "User",
    "fullName": "Full Name",
    "fullNamePlaceholder": "Ex: Ouattara Patrick",
    "emailPlaceholder": "Ex: info at imoney dot africa",
    "select": "Select...",
    "password": "Password",
    "confirmPassword": "Confirm Password",
    "copyPaste": "Copy/Paste",
    "save": "Save",
    "previous": "Previous",
    "next": "Next",
    "confirmRestore": "Do you really want to restore this permission?",
    "organizationCode": "Organization code"
  },
  accounts: {
    "createAccount": "Create Account",
    "createSubAccount": "Create Sub-Account",
    "id": "ID",
    "name": "NAME",
    "type": "TYPE",
    "attachedTo": "ATTACHED TO",
    "status": "STATUS",
    "active": "ACTIVE",
    "inactive": "INACTIVE",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "createAccountTitle": "Create Account",
    "editAccountTitle": "Edit Account",
    "accountName": "Account Name",
    "accountNamePlaceholder": "ex: Ouattara Patrick",
    "accountType": "Account Type",
    "users": "Users",
    "select": "Select...",
    "save": "Save"
  },
  repayments: {
    "excel": "Excel",
    "createRequest": "Make a refund request",
    "code": "Code",
    "organization": "Organization",
    "type": "Type",
    "initiatedBy": "initiated by",
    "validatedBy": "Validated by",
    "amount": "Amount",
    "totalFees": "Total fees",
    "status": "Status",
    "pending": "Pending",
    "validated": "Validated",
    "rejected": "Rejected",
    "reject": "Reject",
    "validate": "Validate",
    "bankAccount": "Bank account",
    "cryptoAccount": "Cryptocurrency Account",
    "payoutAccount": "Payout Account",
    "repaymentRequest": "Refund Request",
    "balance": "BALANCE",
    "repaymentType": "Refund Type",
    "select": "Select...",
    "description": "Description",
    "descriptionPlaceholder": "Enter the company description here",
    "save": "Save",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  reloadings: {
    "excel": "Excel",
    "search": "Search...",
    "createRequest": "Make a reload request",
    "code": "Code",
    "organization": "Organization",
    "description": "Description",
    "amount": "Amount",
    "date": "Date",
    "attachedTo": "ATTACHED TO",
    "status": "Status",
    "pending": "Pending",
    "validated": "Validated",
    "rejected": "Rejected",
    "reject": "Reject",
    "validate": "Validate",
    "edit": "Edit",
    "reloadRequest": "Reload Request",
    "balance": "BALANCE",
    "users": "Users",
    "select": "Select...",
    "descriptionPlaceholder": "Enter the company description here",
    "save": "Save",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results",
    "details": "Details",
    "createdBy": "Created by",
    "validatedBy": "Validated by",
    "name": "Name",
    "notValidatedYet": "Not yet validated",
    "close": "Close"
  },
  business: {
    "addBusiness": "Add Business",
    "editBusiness": "Edit Business",
    "code": "Code",
    "organization": "Organization",
    "name": "Name",
    "description": "Description",
    "maxAmount": "Maximum Amount",
    "validation": "Validation",
    "collectBalance": "Collect Balance",
    "transferBalance": "Transfer Balance",
    "yes": "YES",
    "no": "NO",
    "delete": "Delete",
    "edit": "Edit",
    "alert": "Alert",
    "confirmDelete": "Do you really want to delete this contact",
    "businessName": "Business Name",
    "businessNamePlaceholder": "ex: I-MONEY",
    "descriptionPlaceholder": "ex: enter description here",
    "maxAmountPlaceholder": "ex: 2 000 000",
    "requiresValidation": "Requires validation",
    "category": "Category",
    "selectCategory": "Select a category",
    "save": "Save",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  auth: {
    login: "Login",
    logout: "Logout",
    "loggedOut": "You are logged out",
    "seeYouSoon": "See you soon, we look forward to seeing you again",
    "loginToAccount": "Log in to your account!",
    "emailAddress": "Email address",
    "accountType": "Account Type",
    "selectType": "Select an account type",
    "password": "Password",
    "forgotPassword": "Forgot password?",
    "loginNow": "Log in now",
    "noAccount": "Don't have an account?",
    "createAccount": "Create an account",
    "resetInstructions": "Enter your email address below and we will send you the reset link",
    "send": "Send",
    "backToLogin": "Back to login",
    "createYourAccount": "Create your account",
    "companyName": "Company name / Business name",
    "contact": "Contact",
    "bankName": "Your bank name",
    "rib": "Your IBAN / Bank account number",
    "cryptoAccount": "Cryptocurrency account",
    "confirmPassword": "Confirm password",
    "signUpNow": "Sign up now",
    "alreadyHaveAccount": "Already have an account?",
    "loginHere": "Log in here",
    "allRightsReserved": "All rights reserved to",
    "theAccountsOf": "The accounts of",
    "reloadsList": "Reloads List",
    "myBusinesses": "My Businesses"
  },
  contacts: {
    "addContact": "Add Contact",
    "massImport": "Mass Import",
    "search": "Search",
    "code": "Code",
    "organization": "Organization",
    "firstName": "First Name",
    "lastName": "Last Name",
    "phoneNumber": "Phone Number",
    "transfer": "Transfer",
    "delete": "Delete",
    "edit": "Edit",
    "alert": "Alert",
    "confirmDelete": "Do you really want to delete this contact",
    "no": "No",
    "yes": "Yes",
    "addContactTitle": "Add Contact",
    "editContact": "Edit Contact",
    "phonePlaceholder": "ex: 0720230120",
    "firstNamePlaceholder": "ex: BOLI",
    "lastNamePlaceholder": "ex: FRANK",
    "save": "Save",
    "transferMoney": "Transfer Money",
    "balance": "BALANCE",
    "operators": "Operators",
    "select": "Select...",
    "amount": "Amount",
    "amountPlaceholder": "ex: 2000",
    "business": "Business",
    "transferBtn": "Transfer",
    "importContacts": "Import Contacts",
    "phoneSizeError": "Phone number size error:",
    "phoneFormatError": "Phone number format error:",
    "duplicatePhoneError": "Duplicate phone number:",
    "proceedImport": "You can proceed with the import.",
    "correctErrors": "Correct these errors before continuing.",
    "download": "Download",
    "templateFile": "Template file",
    "country": "Country",
    "selectCountry": "Select country",
    "senegal": "Senegal",
    "ivoryCoast": "Ivory Coast",
    "uploadFile": "Upload file",
    "refresh": "Refresh",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  "tokens": {
    "title": "Token Management",
    "search": "Search token...",
    "refresh": "Refresh",
    "code": "Code",
    "user": "User",
    "email": "Email",
    "type": "Type",
    "deviceId": "Device ID",
    "userAgent": "User Agent",
    "ipAddress": "IP Address",
    "createdAt": "Created At",
    "expiresAt": "Expires At",
    "status": "Status",
    "active": "Active",
    "revoked": "Revoked",
    "revoke": "Revoke",
    "revokeConfirm": "Revocation Confirmation",
    "revokeMessage": "Are you sure you want to revoke this token? This action is irreversible.",
    "token": "Token",
    "cancel": "Cancel",
    "revokeError": "Error revoking token",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  organizations: {
    "createClient": "Create Client",
    "createOrg": "Create organization",
    "customerName": "Customer Name",
    "bank": "Bank",
    "search": "search...",
    "rib": "RIB",
    "cryptocurrency": "Cryptocurrency",
    "email": "EMAIL",
    "status": "STATUS",
    "active": "Active",
    "inactive": "Inactive",
    "users": "Users",
    "accounts": "Accounts",
    "fees": "Fees",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "edit": "Edit",
    "createTitle": "Create Client",
    "editTitle": "Edit Organzation",
    "companyName": "Company Name",
    "companyNamePlaceholder": "I-MONEY AFRICA",
    "phone": "Phone",
    "phonePlaceholder": "ex: 0500457801",
    "cryptoAccount": "Cryptocurrency Account",
    "cryptoPlaceholder": "ex: your email",
    "bankPlaceholder": "ex: ECOBANK",
    "ribPlaceholder": "",
    "requiresValidation": "Requires Validation",
    "maxPayoutAmount": "Max Payout Amount",
    "maxPayoutAmountPlaceholder": "Enter max amount",
    "payoutValidationDelay": "Payout Validation Delay",
    "payoutValidationDelayPlaceholder": "Enter delay in minutes",
    "no": "No",
    "yes": "Yes",
    "type": "Type",
    "legal": "Legal",
    "person": "Person",
    "description": "Description",
    "descriptionPlaceholder": "Enter the company description here",
    "save": "Save",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results",
  },
  countries: {
    "createCountry": "Create Country",
    "code": "Code",
    "search": "search...",
    "countryCode": "Country Code",
    "name": "Name",
    "indicative": "Indicative",
    "currency": "Currency",
    "status": "STATUS",
    "active": "Active",
    "inactive": "Inactive",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "country": "Country",
    "countryCodePlaceholder": "CI",
    "namePlaceholder": "Ivory Coast",
    "indicativePlaceholder": "ex: 225",
    "currencyPlaceholder": "ex: XOF",
    "save": "Save",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  feeTypes: {
    "createFeeType": "Create Fee Type",
    "code": "Code",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "feeType": "Fee Type",
    "namePlaceholder": "Ivory Coast",
    "descriptionPlaceholder": "Enter the company description here",
    "save": "Save",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  providers: {
    "addProvider": "Add Provider",
    "editProvider": "Edit Provider",
    "code": "Code",
    "name": "Name",
    "description": "Description",
    "type": "Type",
    "edit": "Edit",
    "alert": "Alert",
    "confirmDelete": "Do you really want to delete this contact",
    "no": "No",
    "yes": "Yes",
    "providerName": "Provider Name",
    "providerNamePlaceholder": "ex: I-MONEY",
    "descriptionPlaceholder": "ex: enter description here",
    "save": "Save",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  operators: {
    "addOperator": "Add Operator",
    "editOperator": "Edit Operator",
    "code": "Code",
    "operator": "Operator",
    "searchPlaceholder": "Search operators...",
    "mno": "MNO",
    "provider": "Provider",
    "operationType": "Operation Type",
    "paymentMethod": "Payment Method",
    "country": "Country",
    "countryCode": "Country Code",
    "phoneCode": "Phone Code",
    "phoneMask": "Phone Mask",
    "activationDelay": "Activation Delay",
    "description": "Description",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "payin": "PAYIN",
    "payout": "PAYOUT",
    "payinPayout": "PAYIN-PAYOUT",
    "switch": "Switch",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "edit": "Edit",
    "name": "Name",
    "namePlaceholder": "Name ...",
    "mnoPlaceholder": "MNO ...",
    "select": "Select...",
    "paymentMethodPlaceholder": "Payment method ...",
    "phoneCodePlaceholder": "Code ...",
    "phoneMaskPlaceholder": "10",
    "descriptionPlaceholder": "description...",
    "save": "Save",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results",
    "isOtpRequired": "OTP Required",
    "otpInputMask": "OTP Input Mask",
    "otpInputMaskPlaceholder": "Enter OTP input mask"
  },
  permissions: {
    "addPermission": "Add Permission",
    "editPermission": "Edit Permission",
    "code": "Code",
    "searchPlaceholder": "Search permission...",
    "permission": "Permission",
    "description": "Description",
    "viewActions": "View Actions",
    "namePlaceholder": "Name ...",
    "descriptionPlaceholder": "Description ...",
    "actions": "Actions",
    "select": "Select...",
    "save": "Save",
    "edit": "Edit",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  permissionsAdd: {
    "permission": "Permission",
    "namePlaceholder": "Name ...",
    "description": "Description",
    "descriptionPlaceholder": "Description ...",
    "actions": "Actions",
    "select": "Select...",
    "save": "Save",
    "edit": "Edit"
  },
  actions: {
    "code": "Code",
    "action": "Action",
    "description": "Description",
    "addAction": "Add Action",
    "editAction": "Edit Action",
    "name": "Name",
    "namePlaceholder": "Name ...",
    "mno": "MNO",
    "mnoPlaceholder": "MNO ...",
    "status": "Status",
    "select": "Select...",
    "paymentMethod": "Payment Method",
    "paymentMethodPlaceholder": "Payment method ...",
    "phoneCode": "Phone Code",
    "phoneCodePlaceholder": "Code ...",
    "operationType": "Operation Type",
    "payin": "PAYIN",
    "payout": "PAYOUT",
    "payinPayout": "PAYIN-PAYOUT",
    "provider": "Provider",
    "activationDelay": "Activation Delay",
    "active": "ACTIVE",
    "inactive": "INACTIVE",
    "phoneMask": "Phone Mask",
    "phoneMaskPlaceholder": "10",
    "country": "Country",
    "descriptionPlaceholder": "description...",
    "save": "Save",
    "edit": "Edit",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  generalConfig: {
    "notificationUrlConfig": "Notification URL Configuration",
    "url": "URL",
    "urlPlaceholder": "enter notification URL here",
    "generateSecretKey": "Generate your secret key",
    "saveUrl": "Save URL",
    "logoConfig": "Logo Configuration",
    "logo": "Logo",
    "notificationUrlConfigHint": "Receive your transaction notifications at this URL.",
    "logoConfigHint": "This logo is used on your documents and workspace.",
    "logoSizeHint": "Maximum size: {size} KB",
    "transactionValidationHint": "Require manual validation before processing outgoing payments.",
    "copy": "Copy",
    "saveLogo": "Save Logo",
    "transactionValidation": "Transaction Validation",
    "validateTransactions": "Validate transactions",
    "active": "ACTIVE",
    "inactive": "INACTIVE",
    "linkValidityDuration": "Link validity duration (in minutes)",
    "durationPlaceholder": "ex: 30",
    "save": "Save",
    "secretKey": "SECRET KEY",
    "yourSecretKey": "Your secret key",
    "secretKeyNote": "NB: Please copy this code and keep it to use it during your integrations."
  },
  configurations: {
    "addConfig": "Add Configuration",
    "editConfig": "Edit Configuration",
    "config": "Configuration",
    "category": "Category",
    "addBulkConfig": "Bulk add",
    "addToList": "Add to list",
    "pendingList": "Configurations to create",
    "remove": "Remove",
    "value": "Value",
    "alert": "Alert",
    "confirmDelete": "Do you really want to delete this contact",
    "no": "No",
    "yes": "Yes",
    "configName": "Configuration Name",
    "configNamePlaceholder": "ex: PARAM_ENV",
    "valuePlaceholder": "ex: enter value here",
    "description": "Description",
    "descriptionPlaceholder": "ex: enter description here",
    "select": "Select...",
    "provider": "Provider",
    "save": "Save",
    "edit": "Edit",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  fees: {
    "addFee": "Add Fee",
    "bulkFees": "Bulk Fees",
    "code": "Code",
    "organization": "Organization",
    "country": "Country",
    "operator": "Operator",
    "name": "Name",
    "value": "Value",
    "mode": "Mode",
    "feeType": "Fee Type",
    "status": "Status",
    "active": "Active",
    "inactive": "Inactive",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "select": "Select...",
    "percent": "Percentage",
    "valueType": "Value",
    "operatorCollectFee": "OPERATOR COLLECTION FEE",
    "iMoneyCollectFee": "I-MONEY COLLECTION FEE",
    "operatorPayoutFee": "OPERATOR PAYOUT FEE",
    "iMoneyPayoutFee": "I-MONEY PAYOUT FEE",
    "bankRepayment": "BANK REPAYMENT",
    "cryptoRepayment": "CRYPTOCURRENCY REPAYMENT",
    "topup": "TOPUP",
    "fee": "Fee",
    "namePlaceholder": "rate of ...",
    "valuePlaceholder": "2",
    "operators": "Operators",
    "save": "Save",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  balances: {
    "code": "Code",
    "country": "Country",
    "selectBalanceType": "Select a balance type",
    "name": "Name",
    "search": "search...",
    "active": "Active",
    "inactive": "Inactive",
    "balanceType": "Balance type",
    "selectOperator": "Select an operator",
    "selectCountry": "Select a country",
    "operator": "Operator",
    "balanceLimit": "Balance limit",
    "balanceLimitPlaceholder": "Leave empty if there is no limit",
    "type": "Type",
    "status": "Status",
    "balance": "Balance",
    "transfer": "Transfer",
    "delete": "Delete",
    "edit": "Edit",
    "alert": "Alert",
    "confirmDelete": "Do you really want to delete this contact",
    "no": "No",
    "yes": "Yes",
    "addBalance": "Add Balance",
    "editBalance": "Edit Balance",
    "balanceName": "Balance Name",
    "balanceNamePlaceholder": "ex: I-MONEY",
    "description": "Description",
    "descriptionPlaceholder": "ex: enter description here",
    "maxAmount": "Maximum Amount",
    "maxAmountPlaceholder": "ex: 2 000 000",
    "requiresValidation": "Requires Validation",
    "save": "Save",
    "showing": "Showing",
    "outOf": "out of",
    "results": "results"
  },
  export: {
    "excel": "Excel",
    "paymentLink": "Payment Link",
    "transferBalance": "Transfer Balance",
    "collectBalance": "Collect Balance",
    "operationsStatement": "Operations Statement",
    "period": "Period from",
    "to": "to",
    "transactionCode": "TRANSACTION CODE",
    "operation": "OPERATION",
    "fees": "Fees",
    "amount": "AMOUNT",
    "date": "DATE",
    "status": "STATUS",
    "success": "SUCCESS",
    "failed": "FAILED",
    "processing": "PROCESSING",
    "pending": "PENDING",
    "exportFinancialData": "Export Financial Data",
    "clients": "Clients",
    "select": "Select...",
    "detail": "Detail",
    "startDate": "Start Date",
    "endDate": "End Date",
    "exportBtn": "Export"
  },
  header: {
    transferBalance: "TRANSFER BALANCE",
    collectBalance: "COLLECTED BALANCE",
    availableBalance: "AVAILABLE BALANCE",
    mainBalance: "Main balance",
    otherBalances: "Other balances",
  },
  errors: {
    "unexpectedError": "An unexpected error occurred"
  },
  validationform: {
    "passwordRequired": "Password is required",
    "passwordMinLength5": "Password must be at least 5 characters",
    "emailValid": "Email must be a valid email address",
    "emailRequired": "Email is required",
    "typeRequired": "Account type is required",
    "typeInvalid": "Account type must be WEB or API",
    "passwordMinLength6": "Password must be at least 6 characters",
    "confirmPasswordRequired": "Password confirmation is required",
    "confirmPasswordMinLength6": "Password confirmation must be at least 6 characters",
    "passwordMustMatch": "Password confirmation must match the password",
    "companyNameRequired": "Company name is required",
    "nameRequired": "Your name is required",
    "phoneRequired": "Phone number is required",
    "phoneValid": "Please enter a valid phone number",
    "phoneLength": "Phone number must be exactly 10 digits",
    "bankNameRequired": "Bank name is required",
    "ribRequired": "RIB is required",
    "registrationSuccess": "Registration successful, we will contact you for account validation"
  },
  settings: {
    personalInfo: "Personal Information",
    changePassword: "Change Password",
    organizationName: "Organization Name",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    language: "Language",
    "changeMyPassword": "Change My Password",
    "oldPassword": "Old Password",
    "newPassword": "New Password",
    "confirmNewPassword": "Confirm New Password",
    "changePasswordBtn": "Change Password",
    "oldPasswordRequired": "Old password is required",
    "passwordRequired": "Password is required",
    "confirmPasswordRequired": "Password confirmation is required",
    "passwordMinLength": "Password must be at least 6 characters",
    "confirmPasswordMinLength": "Password confirmation must be at least 6 characters",
    "passwordMustMatch": "Password confirmation must match the password",
    "editOrganization": "Edit my organization",
    "contact": "Contact",
    "status": "Status",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "description": "Description",
    "bankDomiciliation": "Bank domiciliation",
    "rib": "IBAN",
    "cryptoAccount": "Crypto account",
    "saveChanges": "Save changes",
    "organizationNameRequired": "Organization name is required",
    "emailRequired": "Email is required",
    "emailInvalid": "Email is invalid",
    "contactRequired": "Contact is required",
    "statusRequired": "Status is required",
    "organizationNotFound": "Organization not found",
    "organizationUpdated": "Organization updated successfully",
    "organizationCode": "Organization code",
    "organizationType": "Organization type",
    "representativeName": "Representative name",
    "representativeIdDocs": "Representative ID document",
    "headOfficeAddress": "Head office address",
    "maxPayoutAmount": "Maximum payout amount",
    "payoutValidationDelay": "Payout validation delay",
    "validatePayoutBeforProcess": "Validate payouts before processing",
    "isTestOrganization": "Test organization",
    "createdAt": "Created on",
    "updatedAt": "Updated on"
  },
}